import { useRef, useState, type FC } from "react";
import SideNav from "../nav/SideNav";
import { ComponentBaseContainer, ComponentContainer, JsonContainer, JsonHelperContainer, JsonTextContainer, StyledClearIcon, StyledCopyIcon } from "./JsonFormatter.style";
import "ace-builds/src-noconflict/mode-json";
import Divider from "@mui/material/Divider";
import AdsComponent from "../AdsComponent";
import { Helmet } from 'react-helmet-async';

const JsonFormatter: FC = () => {

    const [outputJson, setOutputJson] = useState<string>('');
    const [showToast, setShowToast] = useState(false);
    const editorRef = useRef<any>(null);
    const outputRef = useRef<any>(null);

    const handleJsonInput = (value: string) => {
        try {
            if (value === '') {
                setOutputJson('')
            } else {
                const parsedInput = JSON.parse(value);
                const pretty = JSON.stringify(parsedInput, null, 2);
                setOutputJson(pretty)
            }
        }
        catch (err) {
            setOutputJson(String(err))
        }
    }

    const handleClear = () => {
        editorRef.current?.editor?.setValue("", -1);
    }
    const handleCopy = () => {
        const content = outputRef.current?.editor?.getValue();
        content && navigator.clipboard.writeText(content)
            .then(() => {
                setShowToast(true);
                setTimeout(() => setShowToast(false), 1000);
            })
    }


    return (
        <ComponentBaseContainer>
            <Helmet>
                <meta name="description" content="Free online JSON formatter to beautify, validate, and view your JSON data. Easy-to-use developer tool for clean JSON formatting." />
                <meta name="keywords" content="json formatter, json validator, beautify json, online json formatter, json viewer" />
                <title>JSON Formatter Online | Beautify & Validate JSON</title>
            </Helmet>

            <SideNav />
            <ComponentContainer>
                <JsonContainer>
                    <JsonHelperContainer onClick={handleClear}>
                        <StyledClearIcon />
                    </JsonHelperContainer>
                    <Divider />
                    <JsonTextContainer
                        placeholder="Start typing (or) Paste here..."
                        ref={editorRef}
                        mode="json"
                        name="json-editor"
                        wrapEnabled
                        onChange={(val) => handleJsonInput(val)}
                        setOptions={{
                            useWorker: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }}
                    />
                </JsonContainer>
                <Divider orientation="vertical" />
                <JsonContainer>
                    <JsonHelperContainer onClick={handleCopy}>
                        <StyledCopyIcon />
                    </JsonHelperContainer>
                    <Divider />
                    <JsonTextContainer
                        placeholder="Your output will appear here..."
                        ref={outputRef}
                        mode="json"
                        name="json-editor"
                        value={outputJson}
                        wrapEnabled
                        readOnly
                        setOptions={{
                            useWorker: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }}
                    />
                </JsonContainer>
            </ComponentContainer>
            {showToast && (
                <div style={{
                    position: "absolute",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: "#323232",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    opacity: 0.9,
                    fontSize: "14px",
                }}>
                    Copied to clipboard!
                </div>
            )}
            <AdsComponent />
        </ComponentBaseContainer>
    );
}

export default JsonFormatter;